import { Spacer } from '@dot/design-system';
import { Step } from '@repo/common';
import { Trans, useTranslation } from 'react-i18next';
import { default as styled } from 'styled-components';

import { Form } from './components/form';

import defaultAnimation from '@/assets/animations/default.json';
import { Animation } from '@/components/Animation/Animation';
import { SecuredByBadge } from '@/components/SecuredByBadge/SecuredByBadge';
import { withStep } from '@/hoc/with-step';
import { setWorkflowAction } from '@/providers/app-provider/actions';
import { useAppContext } from '@/providers/app-provider/context';
import * as GSC from '@/styles/GlobalStyles';
import { fontHeadingOne, fontTextMdRegular } from '@/styles/helpers';
import { stepToWorkflow } from '@/utils/step-workflow';

const Container = styled.div`
  margin: 32px 0px;

  @media (min-width: ${(p) => p.theme.devices.tablet}) {
    margin: 40px 0px;
  }
`;

const Heading = styled.h1`
  ${fontHeadingOne};
  text-transform: uppercase;
  color: ${(p) => p.theme.colors.oxfordBlue[80]};
  margin-bottom: 6px;
  margin-top: 30px;
  text-align: center;
`;

const Text = styled.p`
  ${fontTextMdRegular};
  color: ${(p) => p.theme.colors.oxfordBlue[80]};
  text-align: center;
`;

export const Introduction = withStep({ only: [Step.INTRO] })(() => {
  const { t } = useTranslation();
  const { dispatch, state } = useAppContext();

  const firstStep = state.customerData?.firstStep;
  const mobileRedirectSkippable = state.customerData?.mobileRedirectSkippable;
  const redirectOptions = {
    unverifiedUrl: state.customerData?.redirect?.unverifiedUrl,
    verifiedUrl: state.customerData?.redirect?.verifiedUrl,
  };

  const getFirstStepWorkflow = () =>
    stepToWorkflow(firstStep ?? '', {
      ...redirectOptions,
      ...(firstStep === 'mobile_redirect' ? { skippable: mobileRedirectSkippable } : {}),
      ...(state.customerData?.firstStepData ? { data: state.customerData.firstStepData } : {}),
    });

  const onFinish = () => {
    const workflow = getFirstStepWorkflow();

    if (workflow) {
      dispatch(setWorkflowAction(workflow));
    }
  };

  return (
    <GSC.PageWrapper>
      <Container>
        <Animation animationData={defaultAnimation} />
        <Heading>{t('steps.introduction.heading')}</Heading>
        <Text>
          <Trans>{t('steps.introduction.infoText')}</Trans>
        </Text>
        <Form onFinish={onFinish} />
        <Spacer $top={1}>
          <SecuredByBadge />
        </Spacer>
      </Container>
    </GSC.PageWrapper>
  );
});
